/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Page from 'material/structure/page/page';
import Content from 'material/structure/content/content';
import Group from 'material/group/group';
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
import ReportCard from 'pages/dashboard/reports/library/reportcard/reportcard';
// states
import EmptyState from 'material/states/empty/empty';
import LoadState from 'material/states/load/load';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/library/library_styles';



/* ========== ~~~~~~~~~~ PAGE : REPORTS : LIBRARY : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class LibraryPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: this.props.clientReports,
        };
    }
    componentDidUpdate(prevProps) {
        //we need to check against data length before updating state
        //this was firing every time the component had a change
        if (prevProps.clientReports.length !== this.props.clientReports.length) {
            this.setState({ items: this.props.clientReports })
        }
    };
    createNewReport = () => {
        this.props.createReport();
        this.props.moveToPage('dashboard/reports/detail');
    };
    _renderReports() {
        return this.state.items.map(item => <ReportCard
                                                key={item.uuid}
                                                data={item}
                                                runReport={() => this.props.getAndRunReport(item.uuid)}
                                                editReport={() => this.props.editReport(item.uuid)}
                                                deleteReport={() => this.props.deleteReport(item.uuid, this.props.accountUUID)}
                                                isLibraryProcessing={this.props.isLibraryProcessing}
                                            />);
    }
    _renderLoadScreen = () => (<Content>
                                    <LoadState
                                        graphicName={`email`}
                                        graphicText={`Sample Emailed Report`}
                                        bodycopy={`We're fetching your Reports.`}
                                    />
                                </Content>);
    _renderEmptyState = () => (<Content>
                                    <EmptyState
                                        graphicName={`email`}
                                        graphicText={`Sample Emailed Report`}
                                        bodycopy={`Put your revenue data into detailed reports, and send them to team members on a daily, weekly, or monthly basis.`}
                                        buttonName={`createreport`}
                                        buttonText={`Create a new scheduled report`}
                                        buttonClick={this.createNewReport}
                                    />
                                </Content>);
    render() {
        return(
            <Page name={`library`} klass={`${this.props.classes.library} processing-${this.props.isLibraryProcessing}`}>
                {!this.props.isDataReceived ? this._renderLoadScreen() :
                    !this.state.items.length ? this._renderEmptyState() :
                    <Content>
                        <Copy name={`page-copy`}>
                            <Title variant={'withctas'}>
                                <h2>All Reports</h2>
                                <Group name={`controls`}>
                                    <CTAs>
                                        <Button type={'action'} action={this.createNewReport} variant={`primary`} name={`createreport`} text={`Create a new report`} />
                                    </CTAs>
                                </Group>
                            </Title>
                        </Copy>
                        <div className={`page-details`}>
                            {this._renderReports()}
                        </div>
                    </Content>
                }
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(LibraryPage);
